import { memo, ReactNode, useCallback, useState } from 'react'
import { useRouterState } from '@tanstack/react-router'

import { TabContext } from './TabContext'

interface IProps {
  children: ReactNode
  defaultTab: IdType
}

export const TabProvider = memo(function TabProvider({ defaultTab, children }: IProps) {
  const {
    location: { hash }
  } = useRouterState()
  const initial = hash?.substring(1) || defaultTab
  const [currentTab, setCurrentTab] = useState<IdType>(initial)

  const handleSetCurrentTab = useCallback((tabId: IdType) => {
    setCurrentTab(tabId)
  }, [])

  return (
    <TabContext.Provider value={{ currentTab, setCurrentTab: handleSetCurrentTab }}>{children}</TabContext.Provider>
  )
})
